export enum FactoryDepartment {
    Metals = 'metals',
    Plastics = 'plastics',
    InjectionMolding = 'injection-molding',
    C3 = 'c3',
    Fabricating = 'fabricating',
    PowderCoating = 'powder-coating',
    Mixing = 'mixing',
    RollForming = 'roll-forming',
    InventoryCage = 'inventory-cage',
    Shipping = 'shipping',
}

export const FACTORY_DEPARTMENT_LABELS: Record<FactoryDepartment, string> = {
    [FactoryDepartment.Metals]: 'Metals',
    [FactoryDepartment.Plastics]: 'Plastics',
    [FactoryDepartment.InjectionMolding]: 'Injection Molding',
    [FactoryDepartment.C3]: 'C3',
    [FactoryDepartment.Fabricating]: 'Fabricating',
    [FactoryDepartment.PowderCoating]: 'Powder Coating',
    [FactoryDepartment.Mixing]: 'Mixing',
    [FactoryDepartment.RollForming]: 'Roll Forming',
    [FactoryDepartment.InventoryCage]: 'Inventory Cage',
    [FactoryDepartment.Shipping]: 'Shipping',
};
